import { render, staticRenderFns } from "./MovementsStock.vue?vue&type=template&id=f4f540d2&"
import script from "./MovementsStock.vue?vue&type=script&lang=js&"
export * from "./MovementsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports